/* tslint:disable */
/* eslint-disable */
/**
 * Distributor API
 * The Cashlink Distributor API enables you to distribute crypto securities and digital securities. It contains all building blocks from investor registration and KYC/AML to brokerage, clearing and settlement processes. While you are in full control of the frontends served to your investors you can use the Cashlink Studio to monitor and manage the activity on your platform.   Note: You cannot access data of investors or investments if they haven\'t been created via the API with your provided API credentials. Also, it\'s not possible to access data of investors that have registered via the Cashlink Signing Module, if you are using this as well.  ### Authentication  Every call to the API must be authenticated via OAuth client credentials. During setup, your point of contact will provide you with your client ID and client secret.   ### Idempotency  For certain POST endpoints, the API uses client-supplied idempotency keys to ensure that requests can be retried safely without performing the same operation twice. Repeated calls to those endpoints with the same idempotency key will return the cached response from the first call. Keys are expected to be set as header parameters with *X-Idempotency-Key*. The recommended approach for interacting with such endpoints is as follows:   - Create a unique, random key, such as a UUIDv4.   - Store the intent to call an endpoint along with the generated key in the client database.   - Flush to disk (e.g. commit an SQL transaction).   - Perform the call to the endpoint.   This ensures that even if the response from the API to a client gets lost, or the client experiences any sort of outage between steps 3 and 4, the client can always safely retry the same action.   If you already have objects corresponding to tasks in the API in your client-side database, you can use their internal IDs as idempotency keys!   ### Monetary values   Monetary values are represented as a combination of amount, decimals & currency. For example, ```{\'amount\': \'40000000\', \'decimals\': 3, \'currency\': \'EUR\'} means \'EUR 40,000.000\'```.   ### Handling documents  The document endpoint can be used to upload documents. Files are uploaded via HTTP multipart. The endpoint will return a document ID that can be used in other requests to refer to that document.   ### Webhooks  You can also register webhooks so that we can notify your application about events with regards to investments. To use that, please provide your point of contact at Cashlink with the following data:   - URL to be used as the target for webhooks  - OAuth client credentials or bearer authentication token so that we can authenticate at your server.  Webhooks are sent every time the status of an investment changes.  **POST <customer-provided URL>**  Webhooks are retried until the called endpoint returns a 2xx.  **Request**  {  \'investment_id\': \'3fa85f64-5717-4562-b3fc-2c963f66afa6\',  \'status\': \'ACCEPTED\',  \'changed_at\': \'2020-12-11T14:59:46.716Z\'  }  ### Concepts  The Cashlink Distributor API is based on the following concepts:  - Persons (legal or natural) that are users on your platform willing to invest are called investors.  - These investors will be able to invest into different financial products issued by different entities. In the API they are called products.  - The purchase of units of such a product takes place within your application and ends with a signed investment contract.  - Now you can create an investment, which contains the investor, the units, the signed investment contract and the accepted date of the investment by the issuer.   - At some point, parts of the investments are returned to the issuer because the outstanding amount has been paid back for example. Such a transaction is called a redemption.    
 *
 * The version of the OpenAPI document: v2
 * Contact: support@cashlink.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ManagedTokenTransferCreate,
  ManagedTokenTransferCreateRequest,
  PaginatedDropdownElementList,
  PaginatedTokenTransferList,
  TokenTransfer,
} from '../models/index';
import {
    ManagedTokenTransferCreateFromJSON,
    ManagedTokenTransferCreateToJSON,
    ManagedTokenTransferCreateRequestFromJSON,
    ManagedTokenTransferCreateRequestToJSON,
    PaginatedDropdownElementListFromJSON,
    PaginatedDropdownElementListToJSON,
    PaginatedTokenTransferListFromJSON,
    PaginatedTokenTransferListToJSON,
    TokenTransferFromJSON,
    TokenTransferToJSON,
} from '../models/index';

export interface TokenTransfersDropdownListRequest {
    amountMax?: string;
    amountMin?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    field?: TokenTransfersDropdownListFieldEnum;
    fromWallet?: string;
    id?: string;
    limit?: number;
    offset?: number;
    ordering?: TokenTransfersDropdownListOrderingEnum;
    productName?: string;
    recipientColumn?: string;
    senderColumn?: string;
    status?: TokenTransfersDropdownListStatusEnum;
    toWallet?: string;
}

export interface TokenTransfersListRequest {
    amountMax?: string;
    amountMin?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    fromWallet?: Array<string>;
    id?: Array<string>;
    limit?: number;
    offset?: number;
    ordering?: TokenTransfersListOrderingEnum;
    productName?: Array<string>;
    recipientColumn?: Array<string>;
    senderColumn?: Array<string>;
    status?: Array<TokenTransfersListStatusEnum>;
    toWallet?: Array<string>;
}

export interface TokenTransfersManagedCreateRequest {
    managedTokenTransferCreateRequest: ManagedTokenTransferCreateRequest;
}

export interface TokenTransfersRetrieveRequest {
    id: string;
}

export interface TokenTransfersValuesRetrieveRequest {
    field: TokenTransfersValuesRetrieveFieldEnum;
    amountMax?: string;
    amountMin?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    fromWallet?: string;
    icontains?: string;
    id?: string;
    ordering?: TokenTransfersValuesRetrieveOrderingEnum;
    productName?: string;
    recipientColumn?: string;
    senderColumn?: string;
    status?: TokenTransfersValuesRetrieveStatusEnum;
    toWallet?: string;
}

/**
 * 
 */
export class TokenTransfersApi extends runtime.BaseAPI {

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async tokenTransfersDropdownListRaw(requestParameters: TokenTransfersDropdownListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropdownElementList>> {
        const queryParameters: any = {};

        if (requestParameters['amountMax'] != null) {
            queryParameters['amount_max'] = requestParameters['amountMax'];
        }

        if (requestParameters['amountMin'] != null) {
            queryParameters['amount_min'] = requestParameters['amountMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['fromWallet'] != null) {
            queryParameters['from_wallet'] = requestParameters['fromWallet'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['recipientColumn'] != null) {
            queryParameters['recipient_column'] = requestParameters['recipientColumn'];
        }

        if (requestParameters['senderColumn'] != null) {
            queryParameters['sender_column'] = requestParameters['senderColumn'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['toWallet'] != null) {
            queryParameters['to_wallet'] = requestParameters['toWallet'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/token-transfers/dropdown/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropdownElementListFromJSON(jsonValue));
    }

    /**
     * Get dropdown elements with IDs and names.
     * Get dropdown elements
     */
    async tokenTransfersDropdownList(requestParameters: TokenTransfersDropdownListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropdownElementList> {
        const response = await this.tokenTransfersDropdownListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async tokenTransfersListRaw(requestParameters: TokenTransfersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedTokenTransferList>> {
        const queryParameters: any = {};

        if (requestParameters['amountMax'] != null) {
            queryParameters['amount_max'] = requestParameters['amountMax'];
        }

        if (requestParameters['amountMin'] != null) {
            queryParameters['amount_min'] = requestParameters['amountMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['fromWallet'] != null) {
            queryParameters['from_wallet'] = requestParameters['fromWallet'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['recipientColumn'] != null) {
            queryParameters['recipient_column'] = requestParameters['recipientColumn'];
        }

        if (requestParameters['senderColumn'] != null) {
            queryParameters['sender_column'] = requestParameters['senderColumn'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['toWallet'] != null) {
            queryParameters['to_wallet'] = requestParameters['toWallet'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/token-transfers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedTokenTransferListFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async tokenTransfersList(requestParameters: TokenTransfersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedTokenTransferList> {
        const response = await this.tokenTransfersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a managed transfer.
     */
    async tokenTransfersManagedCreateRaw(requestParameters: TokenTransfersManagedCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ManagedTokenTransferCreate>> {
        if (requestParameters['managedTokenTransferCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'managedTokenTransferCreateRequest',
                'Required parameter "managedTokenTransferCreateRequest" was null or undefined when calling tokenTransfersManagedCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/token-transfers/managed/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManagedTokenTransferCreateRequestToJSON(requestParameters['managedTokenTransferCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManagedTokenTransferCreateFromJSON(jsonValue));
    }

    /**
     * Create a managed transfer.
     */
    async tokenTransfersManagedCreate(requestParameters: TokenTransfersManagedCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ManagedTokenTransferCreate> {
        const response = await this.tokenTransfersManagedCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async tokenTransfersRetrieveRaw(requestParameters: TokenTransfersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TokenTransfer>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling tokenTransfersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/token-transfers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenTransferFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async tokenTransfersRetrieve(requestParameters: TokenTransfersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TokenTransfer> {
        const response = await this.tokenTransfersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async tokenTransfersValuesRetrieveRaw(requestParameters: TokenTransfersValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling tokenTransfersValuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['amountMax'] != null) {
            queryParameters['amount_max'] = requestParameters['amountMax'];
        }

        if (requestParameters['amountMin'] != null) {
            queryParameters['amount_min'] = requestParameters['amountMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['fromWallet'] != null) {
            queryParameters['from_wallet'] = requestParameters['fromWallet'];
        }

        if (requestParameters['icontains'] != null) {
            queryParameters['icontains'] = requestParameters['icontains'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['recipientColumn'] != null) {
            queryParameters['recipient_column'] = requestParameters['recipientColumn'];
        }

        if (requestParameters['senderColumn'] != null) {
            queryParameters['sender_column'] = requestParameters['senderColumn'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['toWallet'] != null) {
            queryParameters['to_wallet'] = requestParameters['toWallet'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/token-transfers/values/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get distinct string values for a column - no pagination, capped at 50 elements.
     * Get the names one column can have
     */
    async tokenTransfersValuesRetrieve(requestParameters: TokenTransfersValuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.tokenTransfersValuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const TokenTransfersDropdownListFieldEnum = {
    PRODUCT_NAME: 'product_name',
    RECIPIENT_COLUMN: 'recipient_column',
    SENDER_COLUMN: 'sender_column'
} as const;
export type TokenTransfersDropdownListFieldEnum = typeof TokenTransfersDropdownListFieldEnum[keyof typeof TokenTransfersDropdownListFieldEnum];
/**
 * @export
 */
export const TokenTransfersDropdownListOrderingEnum = {
    AMOUNT_DESC: '-amount',
    AMOUNT_ASC: 'amount',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    FROM_WALLET_DESC: '-from_wallet',
    FROM_WALLET_ASC: 'from_wallet',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name',
    RECIPIENT_COLUMN_DESC: '-recipient_column',
    RECIPIENT_COLUMN_ASC: 'recipient_column',
    SENDER_COLUMN_DESC: '-sender_column',
    SENDER_COLUMN_ASC: 'sender_column',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status',
    TO_WALLET_DESC: '-to_wallet',
    TO_WALLET_ASC: 'to_wallet'
} as const;
export type TokenTransfersDropdownListOrderingEnum = typeof TokenTransfersDropdownListOrderingEnum[keyof typeof TokenTransfersDropdownListOrderingEnum];
/**
 * @export
 */
export const TokenTransfersDropdownListStatusEnum = {
    APPROVER_REJECTED: 'approver_rejected',
    COMPLETED: 'completed',
    FAILED: 'failed',
    PENDING: 'pending',
    PROCESSING: 'processing',
    TFA_CONFIRMED: 'tfa_confirmed',
    TFA_REJECTED: 'tfa_rejected',
    TFA_REQUESTED: 'tfa_requested'
} as const;
export type TokenTransfersDropdownListStatusEnum = typeof TokenTransfersDropdownListStatusEnum[keyof typeof TokenTransfersDropdownListStatusEnum];
/**
 * @export
 */
export const TokenTransfersListOrderingEnum = {
    AMOUNT_DESC: '-amount',
    AMOUNT_ASC: 'amount',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    FROM_WALLET_DESC: '-from_wallet',
    FROM_WALLET_ASC: 'from_wallet',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name',
    RECIPIENT_COLUMN_DESC: '-recipient_column',
    RECIPIENT_COLUMN_ASC: 'recipient_column',
    SENDER_COLUMN_DESC: '-sender_column',
    SENDER_COLUMN_ASC: 'sender_column',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status',
    TO_WALLET_DESC: '-to_wallet',
    TO_WALLET_ASC: 'to_wallet'
} as const;
export type TokenTransfersListOrderingEnum = typeof TokenTransfersListOrderingEnum[keyof typeof TokenTransfersListOrderingEnum];
/**
 * @export
 */
export const TokenTransfersListStatusEnum = {
    APPROVER_REJECTED: 'approver_rejected',
    COMPLETED: 'completed',
    FAILED: 'failed',
    PENDING: 'pending',
    PROCESSING: 'processing',
    TFA_CONFIRMED: 'tfa_confirmed',
    TFA_REJECTED: 'tfa_rejected',
    TFA_REQUESTED: 'tfa_requested'
} as const;
export type TokenTransfersListStatusEnum = typeof TokenTransfersListStatusEnum[keyof typeof TokenTransfersListStatusEnum];
/**
 * @export
 */
export const TokenTransfersValuesRetrieveFieldEnum = {
    PRODUCT_NAME: 'product_name',
    RECIPIENT_COLUMN: 'recipient_column',
    SENDER_COLUMN: 'sender_column'
} as const;
export type TokenTransfersValuesRetrieveFieldEnum = typeof TokenTransfersValuesRetrieveFieldEnum[keyof typeof TokenTransfersValuesRetrieveFieldEnum];
/**
 * @export
 */
export const TokenTransfersValuesRetrieveOrderingEnum = {
    AMOUNT_DESC: '-amount',
    AMOUNT_ASC: 'amount',
    CREATED_AT_DESC: '-created_at',
    CREATED_AT_ASC: 'created_at',
    FROM_WALLET_DESC: '-from_wallet',
    FROM_WALLET_ASC: 'from_wallet',
    ID_DESC: '-id',
    ID_ASC: 'id',
    PRODUCT_NAME_DESC: '-product_name',
    PRODUCT_NAME_ASC: 'product_name',
    RECIPIENT_COLUMN_DESC: '-recipient_column',
    RECIPIENT_COLUMN_ASC: 'recipient_column',
    SENDER_COLUMN_DESC: '-sender_column',
    SENDER_COLUMN_ASC: 'sender_column',
    STATUS_DESC: '-status',
    STATUS_ASC: 'status',
    TO_WALLET_DESC: '-to_wallet',
    TO_WALLET_ASC: 'to_wallet'
} as const;
export type TokenTransfersValuesRetrieveOrderingEnum = typeof TokenTransfersValuesRetrieveOrderingEnum[keyof typeof TokenTransfersValuesRetrieveOrderingEnum];
/**
 * @export
 */
export const TokenTransfersValuesRetrieveStatusEnum = {
    APPROVER_REJECTED: 'approver_rejected',
    COMPLETED: 'completed',
    FAILED: 'failed',
    PENDING: 'pending',
    PROCESSING: 'processing',
    TFA_CONFIRMED: 'tfa_confirmed',
    TFA_REJECTED: 'tfa_rejected',
    TFA_REQUESTED: 'tfa_requested'
} as const;
export type TokenTransfersValuesRetrieveStatusEnum = typeof TokenTransfersValuesRetrieveStatusEnum[keyof typeof TokenTransfersValuesRetrieveStatusEnum];
